export class ImageSd {
  '@type' = 'ImageObject';
  'url': string;

  constructor(url: string) {
    this.url = url;
  }
}
